import graphql__119f29d9c3b7f7e7bf28 from "./__generated__/Header_platform.graphql.js";
import graphql__2abf1d1868b482d07908 from "./__generated__/Header_viewer.graphql.js";
import graphql__6be429ac7305e057f1d9 from "./__generated__/Header_navigationItems.graphql.js";
import graphql__6eb55a5ce699105345ee from "./__generated__/Header_authenticationConfig.graphql.js";import { useEffect } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";

import { defineMessages } from "react-intl";
import { NonDesktop, Desktop } from "../Utils/ResponsiveQueries";
import HeaderWithSimpleMenu from "./HeaderWithSimpleMenu";
import HeaderWithComplexMenuDesktop from "./HeaderWithComplexMenuDesktop.js";
import HeaderWithComplexMenuMobile from "./HeaderWithComplexMenuMobile";

import { setSocialSharingEnabled, setComplexMenuEnabled } from "../../reducers/styling";

const Header = props => {
  const platform = useFragment(Header_platform, props.platform);
  const authenticationConfig = useFragment(
    Header_authenticationConfig,
    props.authenticationConfig
  );
  const viewer = useFragment(Header_viewer, props.viewer);
  const navigationItems = useFragment(Header_navigationItems, props.navigationItems);

  const { enableSocialSharing, enableComplexMenu } = platform;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSocialSharingEnabled(enableSocialSharing));
    dispatch(setComplexMenuEnabled(enableComplexMenu));
  }, [enableSocialSharing, dispatch, enableComplexMenu]);

  return enableComplexMenu ? (
    <>
      <Desktop>
        <HeaderWithComplexMenuDesktop
          platform={platform}
          authenticationConfig={authenticationConfig}
          viewer={viewer}
          navigationItems={navigationItems}
        />
      </Desktop>
      <NonDesktop>
        <HeaderWithComplexMenuMobile
          platform={platform}
          authenticationConfig={authenticationConfig}
          viewer={viewer}
          navigationItems={navigationItems}
        />
      </NonDesktop>
    </>
  ) : (
    <HeaderWithSimpleMenu
      platform={platform}
      authenticationConfig={authenticationConfig}
      viewer={viewer}
      navigationItems={navigationItems}
    />
  );
};

const Header_platform = graphql__119f29d9c3b7f7e7bf28;

const Header_viewer = graphql__2abf1d1868b482d07908;

const Header_navigationItems = graphql__6be429ac7305e057f1d9;

const Header_authenticationConfig = graphql__6eb55a5ce699105345ee;

export default Header;

export const intlMessages = defineMessages({
  home: {
    id: "header.logo.alt",
    defaultMessage: "page d'accueil"
  },
  mainMenu: {
    id: "header.button.mainMenu",
    defaultMessage: "Menu principal"
  },
  pageList: {
    id: "header.button.pageList",
    defaultMessage: "Liste des pages"
  }
});
